import { Box, useMediaQuery, useTheme } from '@mui/material';
import CoachPageLayout from '../../../components/CoachPageLayout/CoachPageLayout';
import Calendar from '../../../components/CalenderSettings/Calender/Calender';
import BookingCardsWrapper from '../../../components/CalenderSettings/BookingCardWrapper/BookingCardsWrapper';
import { useAppSelector } from '../../../redux/hooks';
import SubscriptionBanner from '../../../components/SubscriptionBanner/SubscriptionBanner';

export default function BookingSessions() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const coachConfigurations = useAppSelector((state) => state.booking.coachConfigurations);
  const isIpadMini = useMediaQuery('(max-width: 768px)');
  const configErr =
    coachConfigurations.calendar === null ||
    (coachConfigurations.isProvideOnlineConsultations &&
      coachConfigurations.videoCallPlatform === null);

  const getScreenHeight = () => {
    if (isIpadMini && configErr) return '40vh';
    if (configErr && isSmallScreen) return '50vh';
    return '73vh';
  };

  return (
    <CoachPageLayout>
      <Box
        display="flex"
        flexDirection={isSmallScreen ? 'column' : 'row'}
        alignItems="flex-start"
        justifyContent={isSmallScreen ? 'space-around' : 'space-between'}
        maxHeight="100vh"
      >
        <Box
          display="flex"
          alignItems="flex-start"
          sx={{ transform: isMediumScreen ? 'scaleX(0.9)' : 'none' }}
        >
          <Calendar />
        </Box>

        <Box
          flex={0.99}
          display="flex"
          flexDirection="column"
          minHeight={isSmallScreen ? '40vh' : '89vh'}
          maxHeight={isSmallScreen ? '50vh' : '89vh'}
          height="100%"
          width={isSmallScreen ? '100%' : '45%'}
        >
          <SubscriptionBanner isConfigError />
          <Box
            border="1px solid #FFDDC840"
            borderRadius="10px"
            height={getScreenHeight()}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              marginRight: '5px',
              overflowY: 'hidden',
            }}
          >
            <BookingCardsWrapper />
          </Box>
        </Box>
      </Box>
    </CoachPageLayout>
  );
}
